import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { TextChain } from '@/api/types/stowed-element'

/**
 * For each chain a resize touched, where to re-split it from: the first resized member in chain
 * order (the head when none of its members was resized), and the live shape carrying that uid.
 * A chain whose anchor has no shape in `shapes` is skipped.
 *
 * Same `{ anchorUid, riderId }` shape as `chainsAffectedByWrapSourceChange`'s targets, so both
 * feed `redistributeChainStory` the same way.
 */
export function resolveChainReflowAnchors(
  chains: readonly TextChain[],
  resizedUids: readonly string[],
  shapes: readonly ShapeData[]
): { anchorUid: string; riderId: string }[] {
  const resizedUidSet = new Set(resizedUids)
  const anchors: { anchorUid: string; riderId: string }[] = []

  for (const chain of chains) {
    const anchorUid =
      chain.textBox.find((tb) => resizedUidSet.has(tb.uid))?.uid ?? chain.textBox[0]!.uid
    const riderId = shapes.find((s) => s.uid != null && String(s.uid) === anchorUid)?.id

    if (riderId) anchors.push({ anchorUid, riderId })
  }

  return anchors
}
